import React, { useEffect, useState, useContext } from "react";
import { Modal, Button } from "react-bootstrap";
import LoaderInline from "shared/loader/LoaderInline";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { updateKitchenIntegration } from "services/api/kitchen";
import toastify from "shared/toastr";
import UserContext from "store/user-context";
import { IntegrationDeviceDropdown } from "constants/deviceType";

const IntegrationsEdit = ({
  provider,
  kitchenId,
  getListing,
  modalShow,
  closeModal,
  dropdownProvidersList,
}) => {
  const [isLoading, setisLoading] = useState(false);
  const userCtx = useContext(UserContext);
  const validationSchema = Yup.object().shape({
    providerId: Yup.string().required("Please select integration"),
    deviceType: Yup.number().required("Please select device")
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm({
    mode: "all",
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    reset({
      providerId: provider?.id,
      deviceType: provider?.type
    });
  }, [provider]);

  const submitForm = async (data) => {
    setisLoading(true);
    const userId = userCtx?.userInfo?.userId;
    await updateKitchenIntegration({ kitchenId,userId, ...data })
      .then((res) => {
        setisLoading(false);
        getListing();
        toastify("success", res.message);
        closeModal();
      })
      .catch((err) => {
        setisLoading(false);
        toastify("error", err.message);
        closeModal();
      });
  };

  return (
    <Modal
      show={modalShow}
      onHide={closeModal}
      centered
      className="credentials__modal"
      id="provider_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{provider ? "Edit" : "Add"} Integration</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(submitForm)}>
          <div className="basic__info__content">
            <div className="form-row no-gutters">
              <div className="col-md-12 mb-3 pb-3">
                <label htmlFor="providerId">
                  Integration Name <span className="mendatory">*</span>
                </label>
                {dropdownProvidersList && dropdownProvidersList.length ? (
                  <>
                    <select
                      className={`form-control ${
                        errors?.providerId ? "is-invalid" : ""
                      }`}
                      {...register("providerId")}
                    >
                      <option value="">Select Integration</option>
                      {dropdownProvidersList.map((item) => (
                        <option key={item.id} value={item?.id}>
                          {item?.name}
                        </option>
                      ))}
                    </select>
                    {errors.providerId?.message && (
                      <div className="invalid-feedback d-block">
                        {errors.providerId?.message}
                      </div>
                    )}
                  </>
                ) : null}
              </div>

              <div className="col-md-12 mb-3 pb-3 px-0">
                <label htmlFor="deviceType">
                  Type <span className="mendatory">*</span>
                </label>
                <div className="check__wrapper">
                  {IntegrationDeviceDropdown &&
                    IntegrationDeviceDropdown.map((type) => (
                      <label key={type.value} className="check-container mb-0">
                        {type.text}
                        <input
                          type="radio"
                          value={type.value}
                          {...register("deviceType")}
                          defaultChecked={provider?.type === type.value}
                        />
                        <span className="checkmark"></span>
                      </label>
                    ))}
                </div>
                {errors.deviceType?.message && (
                  <div className="invalid-feedback d-block">
                    {errors.deviceType?.message}
                  </div>
                )}
              </div>

              <div className="col-md-12 action__wrapper d-flex flex-column-reverse d-md-flex justify-content-between">
                <button
                  type="button"
                  className="cancel-btn red-btn-ghost btn mr-5"
                  onClick={closeModal}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="prelogin-links-btn mb-4"
                  disabled={isLoading || !isValid}
                >
                  {isLoading ? <LoaderInline /> : provider ? "Save" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default IntegrationsEdit;
